import { OrderSyncProgress } from "@/services/api/orderSync";
import { observable, makeObservable, actionBound } from "mobx";

export enum OrderSyncPhase {
    "IDLE" = "IDLE", // 未开始
    "ACTIVE" = "ACTIVE", // 同步中
    "ENDED" = "ENDED", // 终止态（涵盖成功/失败/取消）
}

export interface OrderSyncState {
    phase: OrderSyncPhase; //  由于用户可以手动点击停止同步，所以依靠OrderSyncProgress中的status判断是否同步结束并非完全可靠
    progress?: OrderSyncProgress;
}

class OrderSyncStore {
    constructor() {
        makeObservable(this, {
            orderSyncState: observable,
            updateSyncProgress: actionBound,
            markSyncAsEnded: actionBound,
            resetSyncProgress: actionBound,
        });
    }

    orderSyncState: OrderSyncState;

    /**
     * 更新服务端的同步状态
     */
    updateSyncProgress(progress: OrderSyncProgress) {
        this.orderSyncState = {
            phase: OrderSyncPhase.ACTIVE,
            progress,
        };
    }

    /**
     * 标记同步已结束
     * 适用场景：同步正常结束、取消同步、同步错误
     */
    markSyncAsEnded() {
        this.orderSyncState = {
            phase: OrderSyncPhase.ENDED,
        };
    }

    /**
     * 重置同步状态（设置为undefined）
     * 适用场景：进入店铺初始化
     */
    resetSyncProgress() {
        this.orderSyncState = {
            phase: OrderSyncPhase.IDLE,
        };
    }
}

export default OrderSyncStore;
